import { ITest, RHookFormTextFieldWithLabel } from "@websential/cosmic";

import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { Grid } from "@mui/material";

interface IEISettingsNonQubecPanel extends ITest { }

export const EISettingsNonQubecPanel: FC<IEISettingsNonQubecPanel> = ({
  testId,
}) => {
  return (
    <Grid
      container
      columnSpacing={6}
      rowSpacing={2}
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Total EI Earnings (Maximum)"
          id="eiSettingsTotalEiEarningsMaximum"
          testId={`${testId}-total-ei-earnings-maximum`}
        />
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <RHookFormTextFieldWithLabel
          label="Basic EI Exemption (Maximum)"
          id="eiSettingsBasicEiExemptionMaximum"
          testId={`${testId}-basic-ei-exemption-maximum`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <FieldWrapper>
          <RHookFormTextFieldWithLabel
            label="Required Contribution (%)"
            id="eiSettingsRequiredContributionPercentage"
            testId={`${testId}-required-contribution-percentage`}
          />
        </FieldWrapper>
      </Grid>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
        <FieldWrapper>
          <RHookFormTextFieldWithLabel
            label="Maximum Contribution"
            id="eiSettingsMaximumContribution"
            testId={`${testId}-maximum-contribution`}
          />
        </FieldWrapper>
      </Grid>
    </Grid>
  );
};
